import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import {  cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsOffersResponse } from "../../Orchestrator/Types/Interface/ICMSOffers";

export async function getCmsOffers(): Promise<
  IApiResponse<ICmsOffersResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCMSOffersAPI;

  const params = new URLSearchParams({
    "populate": "*",
    locale: await getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsOffersResponse>(endpointWithParams, "GET");
}
export async function getCmsOfferDetail(slug: string): Promise<
  IApiResponse<ICmsOffersResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCMSOffersAPI;

  const params = new URLSearchParams({
    "populate": "*",
    "filters[slug][$eq]": slug,
    locale: await getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsOffersResponse>(endpointWithParams, "GET");
}
